import React from 'react';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';

import { useStateContext } from 'app-components/flux/transaction-rules/transactionRulesFormState';

import RuleApplication from './RuleApplication';
import RuleSummaryRow from './RuleSummaryRow';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  main: {
    display: 'flex',
    flex: 'none',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  bottomDivider: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  conditionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flex: 0,
    '> div+div': {
      borderLeft: `1px solid ${theme.palette.divider}`,
    },
  },
  conditions: {
    display: 'flex',
    flex: 1,
    stroke: theme.palette.divider,
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`, // Adjusted to use 12px (1.5) for top/bottom and 16px (2) for left/right
    fontWeight: 500,
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  conditionheading: {
    fontWeight: 500,
  },
  ruleApply: {
    marginTop: 24,
  },
}));

const RuleReview: React.FC = () => {
  const { cx, classes } = useStyles();
  const { state } = useStateContext();
  const { rule, fromTxn } = state;

  return (
    <>
      {fromTxn ? (
        <Box className={classes.row}>{rule && <RuleSummaryRow rule={rule} veritcalWithLabel />}</Box>
      ) : (
        <Card className={classes.main}>
          <Box className={cx(classes.row, classes.conditionsContainer, classes.bottomDivider)}>
            <Box className={classes.conditions}>
              <Typography className={classes.conditionheading} variant='bodyRegular'>
                If my transaction matches this:
              </Typography>
            </Box>
            <Box className={classes.conditions}>
              <Typography className={classes.conditionheading} variant='bodyRegular'>
                Then make these changes:
              </Typography>
            </Box>
          </Box>
          <Box className={classes.row}>{rule && <RuleSummaryRow rule={rule} />}</Box>
        </Card>
      )}
      <Card className={classes.ruleApply}>
        <RuleApplication rule={rule} />
      </Card>
    </>
  );
};

export default RuleReview;
